module.exports = __webpack_public_path__ + "static/web-bot-fraud-d7d8f35ea4a1cb42dd04c46d2a96897a.gif";